import { render, staticRenderFns } from "./M3SERIES.vue?vue&type=template&id=483f81a0&scoped=true"
import script from "./M3SERIES.vue?vue&type=script&lang=js"
export * from "./M3SERIES.vue?vue&type=script&lang=js"
import style0 from "./M3SERIES.vue?vue&type=style&index=0&id=483f81a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483f81a0",
  null
  
)

export default component.exports